// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2CkML","container":"styles_container__3EeQM","title":"styles_title__1HAiG","wrapper":"styles_wrapper__jkI_t","answer":"styles_answer__2BuGY"};